import axios from 'axios';

// Configuration de l'URL de l'API
const API_URL = process.env.REACT_APP_API_URL || '';

// Log pour déboguer en développement
if (process.env.NODE_ENV === 'development') {
  console.log('🔧 Configuration API:', {
    REACT_APP_API_URL: process.env.REACT_APP_API_URL,
    API_URL: API_URL || '(vide - utilise proxy)',
    isProduction: process.env.NODE_ENV === 'production'
  });
}

export const api = {
  // Services
  getServices: () => axios.get(`${API_URL}/api/services`),
  getService: (id) => axios.get(`${API_URL}/api/services/${id}`),
  createService: (data) => axios.post(`${API_URL}/api/services`, data),
  updateService: (id, data) => axios.put(`${API_URL}/api/services/${id}`, data),
  deleteService: (id) => axios.delete(`${API_URL}/api/services/${id}`),

  // Pricing
  getPricing: () => axios.get(`${API_URL}/api/pricing`),
  getPricingByCategory: (category) => axios.get(`${API_URL}/api/pricing/category/${category}`),
  createPricing: (data) => axios.post(`${API_URL}/api/pricing`, data),
  updatePricing: (id, data) => axios.put(`${API_URL}/api/pricing/${id}`, data),
  deletePricing: (id) => axios.delete(`${API_URL}/api/pricing/${id}`),

  // Contact
  submitContact: (data) => axios.post(`${API_URL}/api/contact`, data),
  getContacts: () => axios.get(`${API_URL}/api/contact`),
  getContact: (id) => axios.get(`${API_URL}/api/contact/${id}`),
  updateContact: (id, data) => axios.put(`${API_URL}/api/contact/${id}`, data),
  deleteContact: (id) => axios.delete(`${API_URL}/api/contact/${id}`),

  // Admin
  getStats: () => axios.get(`${API_URL}/api/admin/stats`),
  getRecentContacts: () => axios.get(`${API_URL}/api/admin/recent-contacts`),

  // Upload
  uploadImage: (formData) => {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`
      }
    };
    return axios.post(`${API_URL}/api/upload/image`, formData, config);
  },
  deleteImage: (publicId) => {
    const token = localStorage.getItem('token');
    return axios.delete(`${API_URL}/api/upload/image/${publicId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
  },

  // Settings
  getSettings: () => axios.get(`${API_URL}/api/settings`),
  updateSettings: (data) => {
    const token = localStorage.getItem('token');
    return axios.put(`${API_URL}/api/settings`, data, {
      headers: { Authorization: `Bearer ${token}` }
    });
  },
  uploadLogo: (formData) => {
    const token = localStorage.getItem('token');
    return axios.post(`${API_URL}/api/settings/logo`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`
      }
    });
  },
  deleteLogo: () => {
    const token = localStorage.getItem('token');
    return axios.delete(`${API_URL}/api/settings/logo`, {
      headers: { Authorization: `Bearer ${token}` }
    });
  },

  // About
  getAbout: () => axios.get(`${API_URL}/api/about`),
  updateAbout: (data) => {
    const token = localStorage.getItem('token');
    return axios.put(`${API_URL}/api/about`, data, {
      headers: { Authorization: `Bearer ${token}` }
    });
  },
  uploadFounderImage: (formData) => {
    const token = localStorage.getItem('token');
    return axios.post(`${API_URL}/api/about/founder-image`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`
      }
    });
  },
  deleteFounderImage: () => {
    const token = localStorage.getItem('token');
    return axios.delete(`${API_URL}/api/about/founder-image`, {
      headers: { Authorization: `Bearer ${token}` }
    });
  },

  // Home Images
  getHomeImages: () => axios.get(`${API_URL}/api/home-images`),
  updateHomeImages: (data) => {
    const token = localStorage.getItem('token');
    return axios.put(`${API_URL}/api/home-images`, data, {
      headers: { Authorization: `Bearer ${token}` }
    });
  },
  uploadHeroImage: (formData) => {
    const token = localStorage.getItem('token');
    return axios.post(`${API_URL}/api/home-images/hero`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`
      }
    });
  },
  uploadBenefitsImage: (formData) => {
    const token = localStorage.getItem('token');
    return axios.post(`${API_URL}/api/home-images/benefits`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`
      }
    });
  },
  deleteHeroImage: () => {
    const token = localStorage.getItem('token');
    return axios.delete(`${API_URL}/api/home-images/hero`, {
      headers: { Authorization: `Bearer ${token}` }
    });
  },
  deleteBenefitsImage: () => {
    const token = localStorage.getItem('token');
    return axios.delete(`${API_URL}/api/home-images/benefits`, {
      headers: { Authorization: `Bearer ${token}` }
    });
  }
};

